import { createContext } from 'react'

type SettingsDropdownContextType = () => void

const SettingsDropdownContext = createContext<SettingsDropdownContextType>(null)

export default SettingsDropdownContext
